import axios from 'axios';
import Constants from './components/Constants'
export default class Api {
    constructor(loading, setSnackBar) {
        this.loading = loading;
        this.setSnackBar = setSnackBar;
        this.axios = axios.create({
            baseURL: Constants.adminURL
        })
        this.axios.interceptors.request.use((config) => {
            if (config.url !== ("/api/users/subscribe"))
                this.showLoading()
            try {
                config.headers['Authorization'] = 'Bearer ' + JSON.parse(localStorage.getItem("admintoken")).token
            }
            catch (e) { }
            return config;
        })
        this.axios.interceptors.response.use((r) => {
            this.hideLoading();
            if (r) return r.data;
            else throw Error("No Internet");
        }, (e) => {
            this.hideLoading();
            // eslint-disable-next-line
            if (e.response === undefined) throw { error: "No Internet", status: 400 };
            e.response.data.status = e.response.status;
            throw e.response.data;
        })



    }
    showLoading = () => {
        this.loading(true);
    }
    hideLoading = () => {
        this.loading(false);
    }
    showSnack = (message, type = 'error', duration = 6000) => {
        this.setSnackBar({ type, message, show: true, duration })
    }
    getToken = (defaultt = 'id') => {
        return JSON.parse(localStorage.getItem("token"))[defaultt]
    }
}